import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
	getArticlesRequest: ['isInitialRequest'],
	getArticlesSuccess: ['articles'],
	getArticlesIndexRequest: null,
	getArticlesIndexSuccess: ['articles'],
	getArticleRequest: ['id', 'update'],
	getArticleSuccess: ['article'],
	createArticleRequest: ['article'],
	createArticleSuccess: ['article'],
	duplicateArticleRequest: ['id'],
	duplicateArticleSuccess: ['article'],
	updateArticleRequest: null,
	updateArticleSuccess: ['article'],
	rateArticleRequest: ['id', 'state'],
	rateArticleSuccess: ['user', 'state'],
	updateArticleMeta: ['id', 'meta'],
	updateArticlesRequest: ['articles'],
	updateArticlesSuccess: ['articles'],
	updateArticleFailure: ['error'],
	changeArticleStateRequest: ['id', 'state'],
	changeArticleStateSuccess: ['id', 'state'],
	changeOutdatedStateRequest: ['id', 'state'],
	changeOutdatedStateSuccess: ['id', 'state'],
	removeArticleRequest: ['id'],
	removeArticleSuccess: ['article'],
	changeEditorTitle: ['title'],
	changeEditorContent: ['content'],
	updateArticleStatus: ['status', 'loading'],
	resetArticleState: null,
	unlockArticleRequest: ['id'],

	wsArticleUpdate: ['user', 'article'],
})

export const articleTypes = Types
export default Creators
